import styled from '@emotion/styled';
import { current } from '@zelos/shared/lib/date-util';
import ImageButton from '@/components/comm/ImageButton';
import { breakpointMedium, breakpointSmall } from '@/constants/breakpoints';
import { colors } from '@/constants/colors';
import icBlog from '@/public/images/ic-blog.svg';
import icFacebook from '@/public/images/ic-facebook.svg';
import icYoutube from '@/public/images/ic-youtube.svg';

const Container = styled.div`
display: grid;
width: 100%;
`;

const Title = styled.span`
margin-bottom: 8px;
color: ${colors.brightGrey};
font-size: 12px;
font-weight: 700;
letter-spacing: 0.15px;
line-height: 15px;
`;

const Content = styled.p`
max-width: 75%;
margin-bottom: 26px;
color: ${colors.brightGrey};
font-size: 12px;
font-weight: 400;
letter-spacing: 0.15px;
line-height: 15px;
word-break: keep-all;

@media (max-width: ${breakpointMedium}) {
  max-width: none;
}
`;

const Links = styled.div`
display: flex;
align-items: center;
justify-content: space-between;

@media (max-width: ${breakpointMedium}) {
  display: grid;
  row-gap: 36px;
}

@media (max-width: ${breakpointSmall}) {
  row-gap: 24px;
}
`;

const Anchors = styled.section`
display: flex;
column-gap: 16px;

@media (max-width: ${breakpointSmall}) {
  display: grid;
  row-gap: 8px;
}
`;

const Anchor = styled.a<{ color?: string }>`
color: ${({ color }) => color ?? colors.brightGrey};
font-size: 12px;
font-weight: 500;
letter-spacing: 0.15px;
line-height: 15px;
`;

const Icons = styled.section`
display: flex;
margin: -8px;

& > a {
  display: grid;
  padding: 8px;
}
`;

const FooterCompanyInfo = () => (
  <Container>
    <Title>{current().year()} 프로그래머스</Title>
    <Content>(주)그렙 / 대표 임성수 / 서울특별시 서초구 반포대로 45, 4층(서초동, 명정빌딩) / 사업자등록번호 220-88-75699 / 통신판매업신고 제 2014-서울강남-03241호 / 직업정보제공사업 신고번호 J1200020180027 / 유료직업소개사업 등록번호 (국내)제2021-3210195-14-5-00026호 (국외)서울청 유 제2021-7호 / 프로그래머스 사이트의 모든 콘텐츠, 정보, UI, HTML 소스 등에 대한 무단 복제, 전송, 배포, 크롤링, 스크래핑 등의 행위를 거부하며, 이러한 행위는 관련 법령에 의해 엄격히 금지됩니다.</Content>
    <Links>
      <Anchors>
        <Anchor
          href="https://programmers.co.kr/privacy"
          target="_blank"
          color={colors.black}
        >개인정보 처리방침
        </Anchor>
        <Anchor
          href="https://programmers.co.kr/tos"
          target="_blank"
        >이용약관
        </Anchor>
        <Anchor
          href="https://grepp.oopy.io/intoduce/jobs"
          target="_blank"
        >프로그래머스 인재 채용
        </Anchor>
      </Anchors>
      <Icons>
        <a
          href="https://www.facebook.com/pg/programmersgrepp/about/"
          target="_blank"
          rel="noreferrer"
        ><ImageButton src={icFacebook} alt="facebook" />
        </a>
        <a
          href="https://www.youtube.com/c/Programmerschannel"
          target="_blank"
          rel="noreferrer"
        ><ImageButton src={icYoutube} alt="youtube" />
        </a>
        <a
          href="https://prgms.tistory.com/"
          target="_blank"
          rel="noreferrer"
        ><ImageButton src={icBlog} alt="blog" />
        </a>
      </Icons>
    </Links>
  </Container>
);

export default FooterCompanyInfo;
